import { WorkerBenefitsDetails } from '../components';

export const WorkerBenefits = () => {
  return <WorkerBenefitsDetails />;
};
